module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step.kind === 'email') ? _c('div', {
    staticClass: "klickbox-edit-code clearfix"
  }, [_c('div', {
    staticClass: "klickbox-edit-col"
  }, [_c('div', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.mail_service')))]), _vm._v(" "), _c('textarea', {
    staticClass: "klickbox-code-input klickbox-code__area",
    attrs: {
      "id": "kp-import-form-input",
      "placeholder": _vm.$t('edit.canvas.mail_service_text_area')
    },
    domProps: {
      "value": _vm.orginalForm
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateFormHtml({
          html: $event.target.value,
          id: _vm.step.id,
          customizedForm: _vm.customizedForm
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "klickbox-edit-col"
  }, [_c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.custom_html_form')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.customized_form
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateCustomizedForm({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.redirect_by_mail_service')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.redirect_email_service
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateRedirectEmailService({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _c('span')])]), _vm._v(" "), _c('exception-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.redirect),
      expression: "!redirect"
    }],
    attrs: {
      "selected": _vm.jump[0].destination_step_id,
      "jump": _vm.jump[0]
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7dbdfce9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/config/Email.vue
 ** module id = 876
 ** module chunks = 1
 **/